import React from 'react'
import { connect } from 'react-redux'
import subscriptionOperations from '../../../../redux/css-admin/subscriptionManager/operations'
import * as licenseActions from '../../../../redux/css-admin/licenseManager/actions'
import * as licenseOperations from '../../../../redux/css-admin/licenseManager/operations'
import _ from 'lodash'
import { subscriptionShape } from '../../../../lib/shapes'
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from 'reactstrap'
import { ErrorBoundary, Notification } from 'components'
import LicenseSummary from './LicenseSummary'
import LicenseActions from './LicenseActions'

class RebalanceSubscriptionModal extends React.Component {
  static propTypes = {
    subscription: subscriptionShape.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      renewingLicenses: new Map(),
      isSaving: false,
    }
  }

  getSkusFromSubscription = () => {
    const result = []
    if (!this.props.subscription) return result

    for (let i = 0; i < this.props.subscription.skus.length; i++) {
      const sku = this.lookupSku(this.props.subscription.skus[i].sku)
      if (sku) {
        const renewingCount = [...this.state.renewingLicenses.values()].filter(
          lic => lic.sku === sku.sku,
        ).length
        sku.qty = this.props.subscription.skus[i].qty - renewingCount
        result.push(sku)
      }
    }
    return _.sortBy(result, ['skuCode', 'sku'])
  }

  lookupSku = sku => this.props.refData.skus.get(sku) || {}

  getLicenseFromSubscription = licenseId => {
    const licenseOriginal = this.props.subscription.licenses.find(
      lic => lic.licenseId === licenseId,
    )
    if (!licenseOriginal) throw new Error(`License Id ${licenseId} not found`)
    const licenseRenewing = { ...licenseOriginal }
    return licenseRenewing
  }

  resetLicense = licenseId => {
    const renewing = new Map(this.state.renewingLicenses)
    renewing.delete(licenseId)
    this.setState({ renewingLicenses: renewing })
  }

  renewLicense = licenseId => {
    const renewing = new Map(this.state.renewingLicenses)
    const license = this.getLicenseFromSubscription(licenseId)
    renewing.set(license.licenseId, license)
    this.setState({ renewingLicenses: renewing })
  }

  changeLicense = (licenseId, sku, applyDefaults = true) => {
    const renewing = new Map(this.state.renewingLicenses)
    const license = this.getLicenseFromSubscription(licenseId)
    // change sku
    license.sku = sku
    // apply default
    if (applyDefaults) {
      console.warn('TODO: apply defaults')
    }
    renewing.set(license.licenseId, license)
    this.setState({ renewingLicenses: renewing })
  }

  cancelLicense = (licenseId, cancelledDate) => {
    const renewing = new Map(this.state.renewingLicenses)
    const license = this.getLicenseFromSubscription(licenseId)
    // set cancel date
    license.cancelledDate = cancelledDate
    renewing.set(license.licenseId, license)
    this.setState({ renewingLicenses: renewing })
  }

  submitChanges = async () => {
    this.setState({ isSaving: true })
    const renewingLicenses = [...this.state.renewingLicenses.values()]
    const promises = []
    for (let i = 0; i < renewingLicenses.length; i++) {
      promises.push(this.props.saveLicenseAndHandle(renewingLicenses[i]))
    }
    await Promise.all(promises).then(data => {
      this.props.reloadSubscription(this.props.subscription.subscriptionId)
      this.setState({ isSaving: false })
      this.props.closeModal()
    })
  }

  render = () => {
    const { subscription } = this.props
    const { renewingLicenses, isSaving } = this.state
    if (!subscription) return null
    if (subscription.licenses.length === 0)
      return <Notification color="danger" message="No licenses found." />

    const remainingSkus = this.getSkusFromSubscription()
    const canSave = renewingLicenses.size === subscription.licenses.length

    return (
      <React.Fragment>
        <ModalHeader toggle={this.props.closeModal}>
          Balance Subscription
        </ModalHeader>
        <ModalBody>
          <ErrorBoundary>
            <fieldset>
              <legend>Subscription Skus</legend>
              <SkuItems skus={remainingSkus} />
            </fieldset>
            <Row>
              <Col xs={6}>
                <h5>Existing Licenses</h5>
              </Col>
              <Col xs={6}>
                <h5>Action</h5>
              </Col>
            </Row>
            {subscription.licenses.map(lic => (
              <Row key={lic.licenseId}>
                <Col xs={6}>
                  <LicenseSummary
                    license={lic}
                    lookupSku={this.lookupSku}
                    renewal={this.state.renewingLicenses.get(lic.licenseId)}
                  />
                </Col>
                <Col xs={6}>
                  <LicenseActions
                    license={lic}
                    onCancel={this.cancelLicense}
                    onChange={this.changeLicense}
                    onRenew={this.renewLicense}
                    onReset={this.resetLicense}
                    skus={remainingSkus}
                  />
                </Col>
              </Row>
            ))}
          </ErrorBoundary>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-fixed-width"
            color="link"
            onClick={this.props.closeModal}
          >
            Cancel
          </Button>
          <Button
            className="btn-fixed-width"
            color="primary"
            disabled={isSaving || !canSave}
            onClick={this.submitChanges}
          >
            {isSaving && <i className="fas fa-spinner fa-spin" />}
            {!isSaving && 'Submit'}
          </Button>
        </ModalFooter>
      </React.Fragment>
    )
  }
}
const SkuItems = props => {
  if (!props.skus) return null
  return (
    <React.Fragment>
      <div className="ml-4 mr-4">
        {props.skus.map((sku, i) => (
          <Row key={i}>
            <Col className="text-center" xs={1}>
              {sku.skuCode}
            </Col>
            <Col className="text-center" xs={2}>
              {sku.sku}
            </Col>
            <Col className="text-center" xs={7}>
              {sku.name}
            </Col>
            <Col className="text-center" xs={1}>
              &times;
            </Col>
            <Col
              className={`text-center ${
                sku.qty === 0 ? 'bg-success text-white' : 'bg-danger text-white'
              }`}
              xs={1}
            >
              {sku.qty}
            </Col>
          </Row>
        ))}
      </div>
      <hr />
    </React.Fragment>
  )
}

const mapStateToProps = ({ refData, licenseManager, subscriptionsManager }) => {
  return {
    refData: refData,
    ...licenseManager,
    ...subscriptionsManager,
  }
}

const mapDispatchToProps = {
  ...licenseActions,
  ...licenseOperations,
  reloadSubscription: subscriptionOperations.reloadSubscription,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RebalanceSubscriptionModal)



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/rebalance/RebalanceSubscriptionModal.js